import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleDoc from "../../../../modules/SimpleDoc";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import Api from "../../../../Services/Api";
import {fetchDataAsync} from "../../../../Services/Utils";

class NotificationUploadCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
        };
    };


    handleSubmitFile = async () => {
        try {
            if (R.or(R.isNil(this.state.file), R.isEmpty(this.state.file))) {
                this.handleWarningModalVisibility("File kosong. Silahkan input file terlebih dahulu.", 2);
                return;
            }

            this.props.triggerLoading();

            const formData = new FormData();
            formData.append("file", this.state.file);

            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").uploadExcelNotificationListCustomer,
                menuName: "Management Notification",
                setError: this.props.setError,
                args: formData,
            });
            const component = document.getElementById("inputFileUploadCustomer");
            if(component && component.value){
              component.value = "";
            }
            if (res.ok) {
                const transformedData = res.data.data.map(item => item["Member ID"]);
                this.props.handleAddCustomer(transformedData);
                this.props.onClickClose();
            }
            this.props.triggerLoading();
        } catch (error) {
            console.log("error: ", error)
        }
    };

    handleChangeFile = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            [name]: value,
        }))
    };

    render() {
        return (
            <SimpleModal
                title="Upload List Customer"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                styles={{width: "50%"}}
                content={
                    <ModalContainer>
                        <FlexView vAlignContent="center" className="margin-bottom-20px margin-top-20px">
                            <SimpleDoc
                                name="file"
                                idInputFile="inputFileUploadCustomer"
                                readOnly
                                onChange={(name, value) => this.handleChangeFile(name, value)}
                            />
                        </FlexView>

                        <FlexView hAlignContent="right" className="margin-bottom-20px margin-top-20px">
                            <SimpleButton
                                text="Validasi & Unggah File"
                                onClick={this.handleSubmitFile}
                                className="margin-top-5px"
                            />
                        </FlexView>

                    </ModalContainer>
                }
            />
        );
    };
}

export default NotificationUploadCustomer;